import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { saveMedium } from 'redux/media'
import { Segment, Table } from 'semantic-ui-react'
import StandardDownload from '../../../shared/MediaBrowser/StandardDownload'

const mapStateToProps = (state, ownProps) => {
  const { media } = state.media
  const manualMediumDe = media.find(
    (medium) => medium.id === ownProps.manualMediumIdDe
  )
  const datasheetMediumDe = media.find(
    (medium) => medium.id === ownProps.datasheetMediumIdDe
  )
  const explodedMediumDe = media.find(
    (medium) => medium.id === ownProps.explodedMediumIdDe
  )
  const manualMediumFr = media.find(
    (medium) => medium.id === ownProps.manualMediumIdFr
  )
  const datasheetMediumFr = media.find(
    (medium) => medium.id === ownProps.datasheetMediumIdFr
  )
  const explodedMediumFr = media.find(
    (medium) => medium.id === ownProps.explodedMediumIdFr
  )
  return {
    manualMediumDe,
    datasheetMediumDe,
    explodedMediumDe,
    manualMediumFr,
    datasheetMediumFr,
    explodedMediumFr,
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      saveMedium,
    },
    dispatch
  )
}

class ProductDefaultMediaList extends React.Component {
  render() {
    const dark = config.theme.dark

    // props
    const { manualMediumDe, datasheetMediumDe, explodedMediumDe } = this.props
    const { manualMediumFr, datasheetMediumFr, explodedMediumFr } = this.props

    // event handlers
    const { deleteManualDe, deleteDatasheetDe, deleteExplodedDe } = this.props
    const { deleteManualFr, deleteDatasheetFr, deleteExplodedFr } = this.props

    return (
      <Segment attached className={classNames(['payload', dark && 'inverted'])}>
        <Table
          fixed
          sortable
          compact
          size="small"
          selectable
          singleLine
          basic="very"
          className="spaced mediaList">
          <Table.Body>
            <StandardDownload
              medium={manualMediumDe}
              action={deleteManualDe}
              title={I18n.t('admin.mediaBrowser.user_manual_de')}
            />
            <StandardDownload
              medium={datasheetMediumDe}
              action={deleteDatasheetDe}
              title={I18n.t('admin.mediaBrowser.datasheet_de')}
            />
            <StandardDownload
              medium={explodedMediumDe}
              action={deleteExplodedDe}
              title={I18n.t('admin.mediaBrowser.exploded_diagram_de')}
            />
            <StandardDownload
              medium={manualMediumFr}
              action={deleteManualFr}
              title={I18n.t('admin.mediaBrowser.user_manual_fr')}
            />
            <StandardDownload
              medium={datasheetMediumFr}
              action={deleteDatasheetFr}
              title={I18n.t('admin.mediaBrowser.datasheet_fr')}
            />
            <StandardDownload
              medium={explodedMediumFr}
              action={deleteExplodedFr}
              title={I18n.t('admin.mediaBrowser.exploded_diagram_fr')}
            />
          </Table.Body>
        </Table>
      </Segment>
    )
  }
}

ProductDefaultMediaList = connect(mapStateToProps, mapDispatchToProps)(
  ProductDefaultMediaList
)
export default ProductDefaultMediaList



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductDefaultMediaList.jsx